module.exports = __webpack_public_path__ + "static/media/tile-5.f83abc09.jpg";